import { memo } from 'react';

import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const BreadcrumbsComponent = ({ breadcrumbsBar, breadcrumbsAction }) => (
  <StyledContainer>
    {breadcrumbsBar.map((item, index) => (
      <StyledContainer key={item.id}>
        <Button
          variant="body1"
          key={`button ${item.id}`}
          id={`breadcrumbs-${item.id}`}
          name={index}
          onClick={breadcrumbsAction}
          sx={(theme) => ({
            p: 0,
            color:
              index === breadcrumbsBar.length - 1
                ? theme.palette.text.primary
                : theme.palette.primary.main,
          })}
        >
          {item.name}
        </Button>

        {index !== breadcrumbsBar.length - 1 && (
          <span key={`arrow ${item.id}`}>
            <Typography color="textPrimary">&nbsp;{`>`}&nbsp;</Typography>
          </span>
        )}
      </StyledContainer>
    ))}
  </StyledContainer>
);

BreadcrumbsComponent.defaultProps = {
  breadcrumbsBar: null,
  breadcrumbsAction: () => {},
};

BreadcrumbsComponent.propTypes = {
  breadcrumbsBar: PropTypes.instanceOf(Array),
  breadcrumbsAction: PropTypes.func,
};

export default memo(BreadcrumbsComponent);
